function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState, useContext } from 'react';
import environment from "../../../services/environment";
import Context from "../../../services/context";
import Translator, { t } from "../../../services/translator";
import Select from 'react-select';
import { Spinner } from 'reactstrap';
export default (function () {
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      options = _useState2[0],
      setOptions = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useContext = useContext(Context),
      locale = _useContext.locale,
      update = _useContext.update;

  var getLanguage = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var response, json;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetch(environment.get('api_url') + '/languages');

            case 3:
              response = _context.sent;
              _context.next = 6;
              return response.json();

            case 6:
              json = _context.sent;
              setOptions(json['hydra:member'].map(function (element) {
                return {
                  value: element.locale,
                  label: t(element.locale)
                };
              }));
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              console.error('Error language unavaible... see admin');

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 10]]);
    }));

    return function getLanguage() {
      return _ref.apply(this, arguments);
    };
  }();

  var updateLocales = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(opt) {
      var urlParams, diag, query, newurl;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);
              urlParams = new URLSearchParams(window.location.search);
              diag = urlParams.get('diag');
              query = "?locale=".concat(opt.value);

              if (diag) {
                query += "&diag=".concat(diag);
              }

              newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + query;
              window.history.pushState({
                path: newurl
              }, '', newurl);
              _context2.next = 9;
              return Translator.fetch(opt.value);

            case 9:
              update({
                locale: opt.value
              });
              setLoading(false);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function updateLocales(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    getLanguage();
  }, []); // if (isMultilang !== undefined && isMultilang === false) {
  //   return null;
  // }
  // if (!collector.diag.multilang) {
  //   return null;
  // }

  return /*#__PURE__*/React.createElement("div", {
    className: "locale-choice"
  }, /*#__PURE__*/React.createElement(Select, {
    value: {
      value: locale,
      label: t(locale)
    },
    options: options,
    onChange: updateLocales,
    className: "locale-choice  mt-2",
    disabled: loading
  }), /*#__PURE__*/React.createElement("br", null), loading && /*#__PURE__*/React.createElement(Spinner, {
    size: "sm",
    color: "warning",
    className: "mt-3"
  }));
});